/**
 * Mobile Navigation - Split Panel with Featured Sub-Collections
 * LemonSalt.co.uk - Issue #98
 * Updated: Always show "Ingredients" first
 */

(function() {
  'use strict';

  // Wait for DOM to be ready
  document.addEventListener('DOMContentLoaded', function() {
    initMobileNavSplit();
  });

  function initMobileNavSplit() {
    const mobileNav = document.querySelector('[data-mobile-nav]');
    if (!mobileNav) return;

    const leftPanel = document.querySelector('[data-mobile-nav-left]');
    const rightPanel = document.querySelector('[data-mobile-nav-right]');
    const topLevelButtons = document.querySelectorAll('[data-mobile-nav-trigger]');

    if (!leftPanel || !rightPanel || topLevelButtons.length === 0) return;

    // Reorder menu items to put "Ingredients" first
    reorderMenuItems(leftPanel);

    // Add click handlers to all top-level collection buttons
    topLevelButtons.forEach(function(button) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        handleCollectionClick(button);
      });
    });

    // Auto-select "Ingredients" if it exists, otherwise first item
    const ingredientsButton = findIngredientsTrigger(topLevelButtons);
    if (ingredientsButton) {
      handleCollectionClick(ingredientsButton);
    } else if (topLevelButtons.length > 0) {
      handleCollectionClick(topLevelButtons[0]);
    }
  }

  function reorderMenuItems(leftPanel) {
    const menuList = leftPanel.querySelector('.navmenu');
    if (!menuList) return;

    const menuItems = Array.from(menuList.querySelectorAll('.navmenu-item-toplevel'));
    
    // Find the "Ingredients" item
    const ingredientsItem = menuItems.find(function(item) {
      const trigger = item.querySelector('[data-mobile-nav-trigger]');
      if (!trigger) return false;
      const text = trigger.textContent.trim().toLowerCase();
      return text === 'ingredients';
    });

    // If found, move it to the top
    if (ingredientsItem) {
      menuList.insertBefore(ingredientsItem, menuList.firstChild);
    }
  }

  function findIngredientsTrigger(buttons) {
    return Array.from(buttons).find(function(button) {
      const text = button.textContent.trim().toLowerCase();
      return text === 'ingredients';
    });
  }

  function handleCollectionClick(button) {
    const parentLi = button.closest('[data-navmenu-parent]');
    if (!parentLi) return;

    // Update active state
    document.querySelectorAll('.navmenu-item-toplevel').forEach(function(item) {
      item.classList.remove('active');
    });
    document.querySelectorAll('[data-mobile-nav-trigger]').forEach(function(btn) {
      btn.setAttribute('aria-expanded', 'false');
    });

    parentLi.classList.add('active');
    button.setAttribute('aria-expanded', 'true');

    // Get data from hidden submenu data div
    const submenuData = parentLi.querySelector('[data-submenu-data]');
    if (!submenuData) return;

    const collectionTitle = submenuData.querySelector('[data-collection-title]')?.textContent || '';
    const collectionUrl = submenuData.querySelector('[data-collection-url]')?.textContent || '';
    const hasFeatured = submenuData.querySelector('[data-has-featured]')?.textContent.trim() === 'true';

    // Populate right panel
    populateRightPanel(collectionTitle, collectionUrl, submenuData, hasFeatured);
  }

  function populateRightPanel(title, url, submenuData, hasFeatured) {
    const rightPanel = document.querySelector('[data-mobile-nav-right]');
    if (!rightPanel) return;

    let html = '';

    // Header with title and "View All" link
    html += '<div class="mobile-nav-right-header">';
    html += '<h2 class="mobile-nav-right-title">' + escapeHtml(title) + '</h2>';
    html += '<a href="' + escapeHtml(url) + '" class="mobile-nav-view-all">View All</a>';
    html += '</div>';

    // Featured collections grid (if they exist)
    if (hasFeatured) {
      const featuredCollectionsDiv = submenuData.querySelector('[data-featured-collections]');
      if (featuredCollectionsDiv) {
        const featuredItems = featuredCollectionsDiv.querySelectorAll('.featured-collection-data');
        
        if (featuredItems.length > 0) {
          html += '<div class="featured-subcollections-grid">';
          
          featuredItems.forEach(function(item) {
            const itemTitle = item.querySelector('[data-title]')?.textContent || '';
            const itemUrl = item.querySelector('[data-url]')?.textContent || '';
            const itemImage = item.querySelector('[data-image]')?.textContent || '';
            
            html += '<a href="' + escapeHtml(itemUrl) + '" class="featured-subcollection-item">';
            if (itemImage) {
              html += '<img src="' + escapeHtml(itemImage) + '" alt="' + escapeHtml(itemTitle) + '" loading="lazy">';
            }
            html += '<h3>' + escapeHtml(itemTitle) + '</h3>';
            html += '</a>';
          });
          
          html += '</div>';
        }
      }
    }

    // All sub-collections list
    const subcollectionsDiv = submenuData.querySelector('[data-subcollections]');
    if (subcollectionsDiv) {
      const subcollectionItems = subcollectionsDiv.querySelectorAll('.subcollection-data');
      
      if (subcollectionItems.length > 0) {
        html += '<div class="remaining-subcollections-list">';
        
    subcollectionItems.forEach(function(item, index) {
      const itemTitle = item.querySelector('[data-title]')?.textContent || '';
      const itemUrl = item.querySelector('[data-url]')?.textContent || '';
      
      // SHOW ALL - Don't skip any items
      html += '<a href="' + escapeHtml(itemUrl) + '" class="remaining-subcollection-item">';
      html += escapeHtml(itemTitle);
      html += '</a>';
    });        
        html += '</div>';
      }
    }

    // Update right panel content
    rightPanel.innerHTML = html;
  }

  // Simple HTML escape function
  function escapeHtml(text) {
    const map = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#039;'
    };
    return text.replace(/[&<>"']/g, function(m) { return map[m]; });
  }

})();